import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import InterestForm from './InterestForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class EditInterestModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.createInterest( { ...values } )
        .then( ( category ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( category );
        } );
    }



    render() {
        const initialValues = {
            coverImage: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNMSXzzHwAFlAKyrX7aPAAAAABJRU5ErkJggg==',
        };
        return (
            <DLModal title='Edit Interest'
            closeHandler={ this.props.closeModal }>
                <div>
                    <InterestForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createInterest: ( data ) => {
            return dAPI.post( '/interests', data );
        },
    };
};

export default connect( null, mapDispatchToProps )( EditInterestModal );
